import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

export class CargaBuque {
  static obtenerCargaDiariaBuques () {
    const axios = getAxiosInstance()
    const promise = axios.get('consulta_anuncio_buque_carga')
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static obtenerDetalleCarga (fechaAnuncio) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": {"fecha_anuncio": "${fechaAnuncio}"}}`
    const promise = axios.get(`consulta_anuncio_buque_carga_por_anuncio?r=${filtro}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  static adaptToBackend (values = {}) {
    const {
      fechaAnuncio,
      fechaCarga,
      cuitExportador,
      cereal,
      toneladas
    } = values
    return {
      fechaAnuncio: fechaAnuncio,
      fechaDeCarga: fechaCarga,
      exportador: cuitExportador,
      claveCereal: cereal,
      toneladas: toneladas || null
    }
  }

  static altaDetalleCarga (values) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(values)
    const promise = axios.post(`anuncio_buque_carga`, { valores: { ...valores } })
    return promise.then((lrsAdapter, lrsAdapter))
      .then((result) => { return result })
      .catch(lrsAdapter)
  }

  static updateDetalleCarga (values, fechaAnuncio, fechaCarga, exportador, cereal) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(values)
    const promise = axios.put(`/anuncio_buque_carga`, { valores: { ...valores }, clave: { fecha_anuncio: fechaAnuncio, exportador: exportador, clave_cereal: cereal, fecha_de_carga: fechaCarga } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }

  static deleteDetalleCarga (fechaAnuncio, fechaCarga, exportador, cereal) {
    const axios = getAxiosInstance()
    const filtro = `{"clave": {"fecha_anuncio": "${fechaAnuncio}", "fecha_de_carga": "${fechaCarga}", "exportador": "${exportador}", "clave_cereal": "${cereal.trim()}" }}`
    const promise = axios.delete(`/anuncio_buque_carga?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result)
  }
}
